declare namespace $ {

	type $mol_switch__value_shm_showcase_demo_echarts_1 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_echarts['kind'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_shm_showcase_demo_echarts_2 = $mol_type_enforce<
		({ 
			'bar': string,
			'line': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $shm_echarts__option_shm_showcase_demo_echarts_3 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_echarts['option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $mol_view__sub_shm_showcase_demo_echarts_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_showcase_demo_echarts extends $mol_list {
		kind( next?: string ): string
		Kind( ): $mol_switch
		option( ): any
		Chart( ): $shm_echarts
		Plot( ): $mol_view
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=echarts.view.tree.d.ts.map